var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-select',_vm._g(_vm._b({model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'s-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.list),function(item,i){return _c('s-option',{key:item.id || i,attrs:{"label":item.label || item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }